import { cn } from "@/lib/utils";
import markSrc from "@/assets/brand/logo-mark.png";
import wordmarkSrc from "@/assets/brand/logo-horizontal.png";

// Marca: logo real de Network Mastery (ribbon "N" + logotipo), sin eslóganes.
export function BrandMark({ className }) {
    return (
        <img
            src={markSrc}
            alt="Network Mastery"
            className={cn("h-8 w-8 object-contain", className)}
            draggable={false}
        />
    );
}

export function Wordmark({ className }) {
    return (
        <img
            src={wordmarkSrc}
            alt="Network Mastery"
            className={cn("h-8 w-auto object-contain", className)}
            draggable={false}
        />
    );
}
